import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import { Edit, Delete } from "@mui/icons-material";
import { Typography } from "@mui/material";

import messages from "../../../assets/locale/messages";
import {
  deleteSpecialtyRequest,
  getSpecialtyDetailsRequest,
  getSpecialtyDetailsResponse,
} from "../../../store/Specialties/actions";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import { renderTextEllipsis, setPageMainTitle } from "../../../utils/Helpers";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import EmptyState from "../../../components/EmptyState";

const ViewSpecialties = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const specialtyDetails = useSelector(
    (state) => state.specialties.specialtyDetails
  );
  const lang = useSelector((state) => state.locale.lang);
  const { shared, specialties, pagesTitles } = messages[lang];

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

  useEffect(() => {
    setPageMainTitle("specialtiesManagement");
  }, []);

  useEffect(() => {
    if (id) {
      dispatch(getSpecialtyDetailsRequest(id));
    }
    return () => {
      dispatch(getSpecialtyDetailsResponse({}));
    };
  }, [dispatch, id]);

  const handleDeleteSpecialty = () => {
    dispatch(
      deleteSpecialtyRequest({
        id,
      })
    );
    setOpenDeleteConfirm(false);
  };

  return (
    <div className="view-spcialty-page">
      <div className="d-flex mb-4 flex-column flex-md-row">
        <Typography
          variant="h4"
          sx={{ flexGrow: 1 }}
          className={`page-title ${lang === "en" ? "me-5" : "ms-5"}`}
        >
          {renderTextEllipsis(specialtyDetails
            ? specialtyDetails.title_en|| specialtyDetails.title_ar
              ? lang === "en"
                ? specialtyDetails.title_en
                : specialtyDetails.title_ar
              : pagesTitles.specialtiesView
            : pagesTitles.specialtiesView)}
        </Typography>
        {specialtyDetails && (
          <div className="actions-container d-flex justify-content-end mb-4 mt-4 mt-md-0">
            <Link to={ROUTE_PATHS.editSpecialties.replace(":id", id)}>
              <Button
                label={
                  <>
                    <Edit />
                    <span className="mx-2">{shared.edit}</span>
                  </>
                }
                className={`fsize-14 btn-secondary ${
                  lang === "en" ? "me-3" : "ms-3"
                }`}
              />
            </Link>
            <Button
              label={
                <>
                  <Delete />
                  <span className="mx-2">{shared.delete}</span>
                </>
              }
              outlined
              className="fsize-14"
              onClick={() => setOpenDeleteConfirm(true)}
            />
          </div>
        )}
      </div>
      <div
        className={`px-2 px-md-5 py-5 bg-white rounded-4 ${
          !specialtyDetails && "d-flex justify-content-center"
        }`}
      >
        {specialtyDetails ? (
          <div className="view-details-container">
            <div className="row">
              <div className="mb-4 mb-md-5 col-12 col-md-6">
                <div className="text-dark text-primary fsize-16 mb-2">
                  {shared.lists.enTitle}
                </div>
                <div className="text-gray  fsize-18">
                  {renderTextEllipsis(specialtyDetails.title_en)}
                </div>
              </div>
              <div className="mb-4 mb-md-5 col-12 col-md-6">
                <div className="text-dark text-primary fsize-16 mb-2">
                  {shared.lists.arTitle}
                </div>
                <div className="text-gray  fsize-18">
                  {renderTextEllipsis(specialtyDetails.title_ar)}
                </div>
              </div>
            </div>
            <div className="mb-4 mb-md-5">
              <div className="text-dark text-primary fsize-16 mb-2">
                {specialties.list.relatedCatiegories}
              </div>
              {specialtyDetails.categories?.length ? (
                <div className="text-gray  fsize-18">
                  {specialtyDetails.categories?.map((category) =>
                    lang === "en" ? (
                      <p className="mb-2" key={category.id}>
                        {renderTextEllipsis(category.title_en)}
                      </p>
                    ) : (
                      <p className="mb-2" key={category.id}>
                        {renderTextEllipsis(category.title_ar)}
                      </p>
                    )
                  )}
                </div>
              ) : (
                <div className="text-secondary fsize-18">
                  {specialties.viewSpecialty.noCategories}
                </div>
              )}
            </div>
            <div className="mb-4 mb-md-5">
              <div className="text-dark text-primary fsize-16 mb-2">
                {specialties.list.addedServices}
              </div>
              {specialtyDetails.services?.length ? (
                <div className="text-gray  fsize-18">
                  {specialtyDetails.services?.map((service) =>
                    lang === "en" ? (
                      <p className="mb-2" key={service.id}>
                        {renderTextEllipsis(service.title_en)}
                      </p>
                    ) : (
                      <p className="mb-2" key={service.id}>
                        {renderTextEllipsis(service.title_ar)}
                      </p>
                    )
                  )}
                </div>
              ) : (
                <div className="text-secondary fsize-18">
                  {specialties.viewSpecialty.noServices}
                </div>
              )}
            </div>
          </div>
        ) : (
          <EmptyState
            subTitle={shared.noDataToShow}
            ButtonLabel={shared.back}
            handleBtnAction={() => {
              history.push(ROUTE_PATHS.specialties);
            }}
          />
        )}
      </div>
      <Modal
        open={openDeleteConfirm}
        handleClose={() => setOpenDeleteConfirm(false)}
        title={specialties.deleteSpecialty.title}
        contentClass="mb-5 pb-2 text-primary"
        content={
          <span>{specialties.deleteSpecialty.deleteConfirmationMsg}</span>
        }
        confirmBtnTxt={shared.delete}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        isContentText={false}
        handleConfirm={handleDeleteSpecialty}
        handleCancel={() => setOpenDeleteConfirm(false)}
        modalClass="delete-categories-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
      />
    </div>
  );
};

export default ViewSpecialties;
